import { z } from 'zod';

import { UuidSchema } from '../../common/id/id';

import { MediaKindSchema } from '../media-kind/media-kind';
import { MediaStatusSchema } from '../media-status/media-status';

/**
 * An asset as every client sees it.
 *
 * There is **no `storageKey`, no bucket, and no URL** in this schema, in any
 * schema, ever (N12): a client never learns where bytes live and never
 * constructs a storage URL. A read is a separate, authorized, short-lived mint —
 * `MediaUrl`. The column is also declared `hidden` on the repository, so this
 * is the second lock rather than the only one.
 *
 * `width`/`height`/`blurHash` are null until finalize has decoded the object:
 * before that they are only what the client claimed, and the platform does not
 * publish claims as facts.
 */
export const MediaAssetSchema = z
  .object({
    id: UuidSchema,
    kind: MediaKindSchema,
    status: MediaStatusSchema,
    mime: z.string().min(1),
    sizeBytes: z.number().int().nonnegative(),
    width: z.number().int().positive().nullable(),
    height: z.number().int().positive().nullable(),
    blurHash: z.string().min(1).nullable(),
    sortOrder: z.number().int().nonnegative(),
    createdAt: z.iso.datetime(),
  })
  .strict();

export type MediaAsset = z.infer<typeof MediaAssetSchema>;
